import React from 'react';
import { useFormContext } from 'react-hook-form';
import MeasurementWeightContainer from '../../../../../../../MeasurementsAction/MeasurementWeightContainer';
import {
  returnedTypes,
  measurementType,
  unitsMapping,
} from '../../../../../../../MeasurementsAction/MeasurementEnums';
import MeasurementHeightContainer from '../../../../../../../MeasurementsAction/MeasurementHeightContainer';
import classNames from 'classnames';
import styles from '../index.module.scss';
import useIntakeBlockToggle, { intakeBlocksEnum } from '../../../../hooks/useIntakeBlockToggle';
import {
  isPoundInchType,
  convert,
} from '../../../../../../..//MeasurementsAction/MeasurementHelper';
import useStores from '../../../../../../../../hooks/useStores';

const MeasurementBlock = () => {
  const {
    setValue,
    getValues,
    control,
    clearErrors,
    setError,
    formState: { errors },
  } = useFormContext();
  const { isOn, isRequired } = useIntakeBlockToggle();
  const { measurementsStore } = useStores();

  const convertMeasurementValue = (name: string, type: measurementType) => {
    const measurementValue = getValues(name);
    if (isPoundInchType(measurementsStore.unitsMapping) && measurementValue) {
      return convert(Number(measurementValue), type, unitsMapping['kg/cm'], getValues('inch'));
    }
    return measurementValue ? Number(measurementValue) : undefined;
  };

  const validateHeightContainerFields = () => {
    const heightValue = convertMeasurementValue('height', measurementType.height);
    if (heightValue && (heightValue > 240 || heightValue < 110)) {
      setError('height', {
        type: 'custom',
        message: 'Height is out of range',
      });
    } else {
      clearErrors('height');
    }
  };

  if (!isOn(intakeBlocksEnum.physical)) {
    return null;
  }

  return (
    <div className="flex items-center gap-4">
      <div className={classNames(styles.inputWrapper, styles.measurementWrapper)}>
        <MeasurementHeightContainer
          returnedType={returnedTypes.unit}
          measureType={measurementType.height}
          setValue={setValue}
          getValues={getValues}
          control={control}
          required={isRequired(intakeBlocksEnum.physical)}
          textFieldClasses={{
            root: styles.inputField,
            wrapperClassName: styles.textFieldWrapper,
            endAdornmentClassName: styles.endAdornmentWrapper,
            input: styles.mesurementInput,
          }}
          isHideMeasurementsIcon
          wrapperClassName={styles.heightFieldsWrapper}
          onBlur={() => validateHeightContainerFields()}
          onInput={() => clearErrors('height')}
          error={!!errors?.height}
          helperText={errors?.height?.message as string}
        />
      </div>
      <div className={classNames(styles.inputWrapper, styles.measurementWrapper, styles.lastField)}>
        <MeasurementWeightContainer
          returnedType={returnedTypes.unit}
          measureType={measurementType.weight}
          setValue={setValue}
          getValues={getValues}
          control={control}
          required={isRequired(intakeBlocksEnum.physical)}
          textFieldClasses={{
            root: styles.inputField,
            wrapperClassName: styles.textFieldWrapper,
            endAdornmentClassName: styles.endAdornmentWrapper,
            input: styles.mesurementInput,
          }}
          isHideMeasurementsIcon
          error={!!errors?.weight}
          helperText={errors?.weight?.message as string}
          onInput={() => clearErrors('weight')}
        />
      </div>
    </div>
  );
};
export default MeasurementBlock;
